/* globals process */

// eslint-disable-next-line local-rules/never-use-saga-spawn
import { spawn } from 'redux-saga/effects';

import Logger from '../../tools/Logger';

const log = Logger.child({ component: 'sagas/SpawnedTaskManager' });

const spawnedTasks = {};
export const DEFAULT_GROUP = 'default';

function removeSpawnedTask(group, taskId) {
  const groupOfTasks = spawnedTasks[group];
  if (groupOfTasks) {
    const task = groupOfTasks[taskId];
    if (task) {
      delete spawnedTasks[group][taskId];
    }
  }
}

function getSpawnedTaskRemover(group, taskId) {
  return () => {
    removeSpawnedTask(group, taskId);
  };
}

export function taskManagerSpawnFactory(group = DEFAULT_GROUP) {
  return function* (...args) {
    const task = yield spawn(...args);
    spawnedTasks[group] = spawnedTasks[group] || {};
    spawnedTasks[group][task.id] = task;
    // Ensures that we stop tracking tasks that finish
    task
      .toPromise()
      .then(getSpawnedTaskRemover(group, task.id), getSpawnedTaskRemover(group, task.id));
    return task;
  };
}

export function removeSpawnedTasksInGroup(group) {
  if (!group) {
    log.info(
      'Trying to remove spawned task, but no group passed. Verify call to removeAndStopHandlers.',
    );
    return;
  }
  const spawnedTasksInGroup = spawnedTasks[group];
  if (spawnedTasksInGroup) {
    const taskIds = Object.keys(spawnedTasksInGroup);
    taskIds.forEach(taskId => {
      const task = spawnedTasksInGroup[taskId];
      task && task.cancel();
      removeSpawnedTask(group, taskId);
    });
  }
}

export function cancelAllTasks() {
  Object.keys(spawnedTasks).forEach(group => {
    removeSpawnedTasksInGroup(group);
  });
}

export let getSpawnedTasks = () => {
  throw new Error('Not Implemented');
};

if (process.env.NODE_ENV === 'test') {
  getSpawnedTasks = () => spawnedTasks;
}
